// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Project Image Galleries
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { abstractBg } from "./abstractBg";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------



// | ------------------------------------------------------------------------


function projectImgGallery(showMarkers, scrollAnimation) {

  var projectsPin = document.querySelector(".project-images-pin");

  // Check if the element exists before proceeding
  if (!projectsPin) {
    return; // Exit the function if the element is not found
  } 

  if(projectsPin){


    // Get array of images
    var gallery = scrollAnimation;
    var galleryImages = scrollAnimation.querySelectorAll(".project-image");
    var images = gsap.utils.toArray(galleryImages);

    // Number of images
    let imagesLength = images.length;

    // When to end the animation based on number of images
    let endTotal = imagesLength * 500;
  
    // Get height of images
    const projectImgHeight = document.querySelector(".project-image").offsetHeight + "px";

    if(imagesLength > 0){
      // Set the gallery height
      gsap.set(gallery, { height: projectImgHeight});

    
      let projectGallery = gsap.timeline({
        paused: "true",
        scrollTrigger: {
          trigger: gallery,        
          start: "center center",
          end: "+=" + endTotal + "", //"+=3000",
          pinReparent: true,
          pin: projectsPin,
          pinnedContainer: projectsPin,              
          markers: showMarkers,
          scrub: true,
          //snap: [0, 0.5, 1],
          snap: {
            snapTo: 1 / (images.length - 1), //[0, 0.5, 1],
            duration: {min: 0.5, max: 1}, // the snap animation should be at least 0.25 seconds, but no more than 0.75 seconds (determined by velocity)
            //duration: {min: 0, max: 0.15},
            delay: 0, //.125, // wait 0.125 seconds from the last scroll event before doing the snapping
            ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
          },      
          onLeave: (scrollAnimation) => {

            const abstractSection = document.querySelector(".animated-abstract-section");
            const gallerySections = document.querySelectorAll('.project-img-gallery');
            const lastGallery = gallerySections.length - 1;
            const triggerElement = scrollAnimation.trigger;

            if (gallerySections[lastGallery] === triggerElement) {
              if(abstractSection){
                abstractBg(showMarkers, abstractSection);
              }
            }
            
          },                   
          id: "Project-Images",
        },
      });

      let min = 1;

      images.forEach(image => {
        gsap.set(image, { position: "absolute", zIndex: min++, })
      });

      images.forEach((image, index) => {

        var firstImage = images[0];
        var lastImage = images[images.length- 1];

        // First Image in Gallery
        if(image === firstImage){

          gsap.set(image, { y: 0 });

          projectGallery
          // image leaves
          .to(image,{y: projectImgHeight, rotate: 6, scale: .8, duration: 2, ease: "power2.out",}, .5)

        // Last Image in Gallery
        }else if(image === lastImage){

          gsap.set(image, { y: projectImgHeight });

          projectGallery
            // image enters
            .to(image,{y: 0, duration: 2, ease: "power2.in",}, "<-=1")

        // Middle Images
        }else{

            gsap.set(image, { y: projectImgHeight });

            projectGallery
              // image enters
              .to(image,{y: 0, duration: 2, ease: "power2.in",}, "<-=1")

              // image leaves
              .to(image,{y: projectImgHeight, rotate: 6, scale: .8, duration: 2, ease: "power2.out"}, "<+=3.5")    
        
        } 
      })
    }

  }

}

export { projectImgGallery };
